import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import GoogleMap from "./components/Plugins/GoogleMap";
import "cropperjs/dist/cropper.css";
import { i18n } from "@/plugins/i18n";
import infiniteScroll from 'vue-infinite-scroll'
import mdiVue from 'mdi-vue/v2'
import * as mdijs from '@mdi/js'
Vue.use(infiniteScroll)
Vue.component("GoogleMap", GoogleMap);
Vue.config.productionTip = false;
Vue.use(Antd);
import * as VueGoogleMaps from "vue2-google-maps";
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);
Vue.use(mdiVue, {
  icons: mdijs
}) 
export const eventBus = new Vue({
  data: {
    components: null
  },
  methods: {
    getOrderIndex(index) {
      this.$emit("indexwasGetted", index);
    }
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA10mAjAB5_eaiOonPDslkzEOXExeGDsos",
    libraries: "geometry"
  },
  installComponents: true
});

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'th'
  }

  // set the current language for i18n.
  i18n.locale = language
  next()
})

new Vue({
  router,
  store,
  Antd,
  i18n,
  render: function (h) {
    return h(App);
  }
}).$mount("#app");
